import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FiltersService, TransportListViewMode } from '../../../../store/models/filter.model';

@Component({
  selector: 'ui-monitoring-list-view-toolbar',
  templateUrl: './monitoring-list-view-toolbar.component.html',
  styleUrls: ['./monitoring-list-view-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringListViewToolbarComponent {
  @Input() listFiltersService: FiltersService;
  @Input() listViewModeOptions?: TransportListViewMode;
}
